<template>
  <div
    class="dropzone"
    :class="{
      'dropzone-active': $refs.upload && $refs.upload.dropActive
    }"
  >
    <file-upload
      :drop="true"
      :multiple="false"
      ref="upload"
      @input-file="handleFile"
    >
    <small style="margin-left: 24px;">{{ $t('employee.comp.clickOrDrop') }}</small>
      <!-- <buttonc label="Dateien auswählen" icon="fa-plus"/> -->
    </file-upload>

    <ul v-if="Object.keys(files).length > 0" class="upload-list">
      <li v-for="(fileData, id) in files" :key="id">
        <!-- <small>{{ fileData.f.name + ' - ' + fileData.f.size | formatSize }}</small> -->

        <!-- <small v-if="fileData.error"><br/>{{ fileData.error }}</small> -->

        <p v-if="fileData.sizeWarning">
          <buttonc
            icon="fa-play"
            label="Fortfahren"
            type="green"
            v-on:click="continueSizeCheck(id)"
          />
          <buttonc
            icon="fa-stop"
            :label="$t('settings.ui.cancel')"
            v-on:click="removeFile(id)"
          />
        </p>

        <bar :min="0" :max="100" :value="fileData.uploadProgress"/>
      </li>
    </ul>
  </div>
</template>

<script>
import buttonc from '../uicomponents/button';
import FileUpload from 'vue-upload-component';
import axios from 'axios';

export default {
  name: 'fileUploadBoxCopy',
  components: { FileUpload, buttonc },

    props: [
        "employee",
        "sirid"
    ],
  data() {
    /**
     * @type {Object.<string,{f: VUFile, error: string, sizeWarning: boolean, uploadProgress: number|null}>} files
     */
    const files = {};
    return { files };
  },
  methods: {
    /**
     * @param {string} fileId
     */
    removeFile(fileId) {
      this.$delete(this.files, fileId);
    },
    showErrorAlert(msg){
      this.$helpers.OpenAlert({header: this.$t('employee.comp.uploadFailed'), description: msg, disableAccept: true, cancelLabel: this.$t('employee.data.ok')})
    },
    /**
     * @param {VUFile|null} newFile
     * @param {VUFile|null} oldFile
     */
    async handleFile(newFile, oldFile) {
      if (!newFile) return;

      // Check file size
      if (newFile.size > 32 * 1000 * 1000) {
        this.files = {
          ...this.files,
          [newFile.id]: {
            f: newFile,
            error: this.showErrorAlert(this.$t('employee.comp.uploadFailedSize', { name: newFile.name })),
            sizeWarning: false,
          },
        };
        return;
      }

      this.files = {
        ...this.files,
        [newFile.id]: {
          f: newFile,
          error: null,
          sizeWarning: false,
        },
      };
      this.uploadFile(newFile).catch(error => {
        this.files = {
          ...this.files,
          [newFile.id]: {
            ...this.files[newFile.id],
            error: this.showErrorAlert(this.$t('employee.comp.uploadFailedWithError', {
                name: newFile.name,
                msg: error.message
            })),
          },
        };
      });
    },
    /**
     * @param {VUFile} file
     */
    async uploadFile(file) {
      const fileToUpload = this.files[file.id];
      // const companyGroupId = this.$store.state.companyId;

      const formData = new FormData();
      formData.append('file', file.file, file.name);
      formData.append('companyId', `${ this.$store.state.companyId }`);
      formData.append('uploadType', 'SOCIALINSURANCEREGISTRATION');
      formData.append('employeeId', this.employee.id);
      formData.append('socialInsuranceRegistrationId', this.sirid);

      try {
        const response = await axios.post('/api/sec/file/upload', formData, {
          headers: {
            Authorization: 'Bearer ' + this.$store.state.jwt,
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: progressEvent => {
            console.log(
              (progressEvent.loaded / progressEvent.total) * 100 + '%',
            );
            this.$set(
              fileToUpload,
              'uploadProgress',
              (progressEvent.loaded / progressEvent.total) * 100,
            );
          },
        });
        console.log(response.data);
        this.$emit('upload-success', fileToUpload, response);
        // Remove file after upload or error after 5/10s
        /* setTimeout(() => {
          this.$delete(this.files, file.id);
        }, 5 * 1000);*/
      } catch (error) {
        this.showErrorAlert(this.$t('employee.comp.uploadFailedWithError', {
            name: file.name,
            msg: error.message
        }));
        this.$set(
          fileToUpload,
          'error',
            this.$t('employee.comp.uploadFailedWithError', {
                name: file.name,
                msg: error.message
            }),
        );
        // Remove file when an error occurs after 2s
        setTimeout(() => {
          this.$delete(this.files, file.id);
        }, 2 * 1000);
      }
    },
  },
  filters: {
    formatSize(size) {
      if (size > 1000 * 1000 * 1000 * 1000) {
        return (size / 1000 / 1000 / 1000 / 1000).toFixed(2) + ' TB';
      } else if (size > 1000 * 1000 * 1000) {
        return (size / 1000 / 1000 / 1000).toFixed(2) + ' GB';
      } else if (size > 1000 * 1000) {
        return (size / 1000 / 1000).toFixed(2) + ' MB';
      } else if (size > 1000) {
        return (size / 1000).toFixed(2) + ' KB';
      }
      return size.toString() + ' B';
    },
  },
};
</script>

<style scoped>
.dropzone {
  width: 100%;
  padding-top:5px;
  border: 2px dashed var(--contrast-5);
  background-color: var(--bg);
  transition: border 125ms ease, background-color 125ms ease;
  color: var(--contrast-4);
}

.dropzone-active {
  border-radius: 6px;
  background-color: var(--contrast-1);
}

.upload-list {
  list-style: none;
}

.upload-list li {
  display: flex;
  align-items: center;
}

.upload-list li .bar {
  flex: 100% 1;
}
</style>
